// Import 3rd-party dependencies
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

// Import project-specific dependencies
import { ApiService } from '@app/services/api.service';
import { environment } from '@app/environments/environment';
import { DxchubNotificationService } from '../notifications/dxchub/dxchub-notification.service';
export interface IAnnouncement {
  from?: string;
  message: string;
  link: string;
}
@Injectable({
  providedIn: 'root'
})
export class AnnouncementsService extends ApiService {
  constructor(httpClient: HttpClient, private dxchubNotificationService: DxchubNotificationService) {
    super(httpClient);
  }
  
  announcementList$ = this.getNotifications();

  private getNotifications(): Observable<IAnnouncement[]> {
    return this.dxchubNotificationService.getAllAnnouncements().pipe(
      map((nlist) => nlist.filter((item) => item.isTopBanner)),
      map((notifications) => {
        let notificationList = [];
        notifications.forEach((element) => {
          notificationList.push({
            from: element.fullName,
            link: element.link,
            message: element.message
          });
        });
        return notificationList.length ? notificationList : null;
      })
    );
  }

  // Check if the user has admin permission
  checkForAdminAccess(email: string) : Observable<boolean> {
     return this.get<any>(`${environment.DEPS.ADMIN_API.URL}/cms/adminusers?email=${email}`).pipe(map((res)=>{
      return (res != null && res.length > 0) 
    }));
  }

  // Check if the user is a super admin - For remove option in quicklinks and profile links pages
  isSuperAdmin(email: string) {
    return this.get<any>(`${environment.DEPS.ADMIN_API.URL}/cms/adminusers?email=${email}`).pipe(
      map((res) => {
        if (res != null && res.length > 0) {
          return res[0].isSuperAdmin;
         }else{ 
          return false;
        }
      }
    ));
  }
}
